// extracted by mini-css-extract-plugin
export default {"wrapper":"main_wrapper__Gp2I-","Main":"main_Main__TgpeS"};